import TransactionCommonModal from '../../common/TransactionCommonModal';
import ReceiveForm from './ReceiveCryptoForm';

const ReceiveCryptoModal = ({ open, onClose, row }) => {
    return (
        <TransactionCommonModal
            open={open}
            onClose={onClose}
            heading="Receive Crypto"
            bottomButtonText=""
            onBottomButtonClick={() => {}}
            showBackButton={false}>
            <ReceiveForm isModal={true} open={open} row={row} />
        </TransactionCommonModal>
    );
};

export default ReceiveCryptoModal;
